<template>
  <div>
    <div class="tableContainer mx-auto">
      <div class="d-flex my-3">
        <h6>All {{ companyName }} Company Shalois</h6>
        <div class="add-btn ml-auto">
          <button
            class="btn show-modal"
            data-toggle="modal"
            data-target="#myModal"
          >
            Add New Shaloi
          </button>
        </div>
      </div>
      <div class="modal fade" id="myModal">
        <div class="modal-dialog modal-dialog-centered myModal-md">
          <div class="modal-content">
            <div class="modal-body">
              <Toast position="bottom-right" group="br" />
              <div class="form col-lg-12 mx-auto bg-white">
                <h6 class="text-center mt-2 mb-3 heading">
                  Register Shalois of your company
                </h6>
                <form class="col-lg-11 mx-auto" @submit.prevent="newShaloi()">
                  <div class="inputs d-flex flex-wrap mx-auto">
                    <div class="form-group mx-2 px-0 my-2 col-lg-3 col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        name="firstname"
                        v-model="shaloiData.Firstname"
                        placeholder="shaloi first name"
                        required
                      />
                    </div>
                    <div class="form-group mx-2 px-0 my-2 col-lg-3 col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        name="lastname"
                        v-model="shaloiData.Lastname"
                        placeholder="shaloi last name"
                        required
                      />
                    </div>
                    <div class="form-group mx-2 px-0 my-2 col-lg-2 col-sm-6">
                      <select
                        class="form-control"
                        v-model="shaloiData.Gender"
                        name="gender"
                        id="gender"
                        required
                      >
                        <option disabled value>--Gender--</option>

                        <option value="M">Male</option>

                        <option value="F">Female</option>
                      </select>
                    </div>
                    <div class="form-group mx-2 px-0 my-2 col-lg-3 col-sm-6">
                      <input
                        type="email"
                        class="form-control"
                        name="email"
                        v-model="shaloiData.email"
                        placeholder="shaloi email"
                        required
                      />
                    </div>

                    <div
                      class="form-group mx-2 px-0 my-2 col-lg-3 col-md-6 col-11 col-sm-6"
                    >
                      <select
                        class="form-control"
                        v-model="shaloiData.selector"
                        @change="getCode()"
                        name="phoneCodes"
                        id="phoneCodes"
                        required
                      >
                        <option
                          v-for="phoneCode in phoneCodes"
                          v-bind:value="phoneCode.code"
                          :key="phoneCode.code"
                        >
                          {{ phoneCode.code }} --
                          {{ phoneCode.name }}
                        </option>
                      </select>
                    </div>

                    <div
                      class="input-group col-lg-4 my-2 col-md-6 col-12 col-sm-6 "
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">{{
                          currentCode
                        }}</span>
                      </div>

                      <input
                        type="number"
                        class="form-control"
                        placeholder="Phone number"
                        name="phone"
                        id="phone"
                        v-model="shaloiData.phone"
                        autocomplete="autocomplete_off_hack_xfr4!k"
                        aria-describedby="basic-addon1"
                        required
                      />
                    </div>

                    <div class="text-center my-2 col-lg-4 add-shaloi-btn-div">
                      <button
                        type="submit"
                        name="newshaloi"
                        class="btn btn-primary"
                      >
                        Add shaloi
                        <span
                            v-if="addShaloiClicked"
                            class="spinner-border spinner-border-sm ml-2 my-auto"
                          ></span>
                      </button>
                    </div>
                  </div>
                </form>

                <div class="added-shalois col-lg-11 mx-auto">
                  <div v-if="!showTable" class="table_placeholder">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="120"
                        height="120"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                          d="M14 14.252v2.09A6 6 0 0 0 6 22l-2-.001a8 8 0 0 1 10-7.748zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm6 6v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z"
                          fill="rgba(149,164,166,1)"
                        />
                      </svg>
                      <p id="add-buses-text">Added Shalois will appear here</p>
                    </div>
                  </div>

                  <div
                    v-if="showTable"
                    class="table-container card my-3 col-lg-12 p-0 mx-auto"
                  >
                    <table class="table col-lg-12">
                      <thead class="bg-success">
                        <tr>
                          <th>#</th>
                          <th>Shaloi Names</th>
                          <th>Shaloi Email</th>
                          <th>Shaloi Contacts</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="shaloi in AddedShalois" :key="shaloi.no">
                          <td>{{ shaloi.no }}</td>
                          <td>
                            {{ shaloi.Firstname + " " }}{{ shaloi.Lastname }}
                          </td>
                          <td>{{ shaloi.Email }}</td>
                          <td>{{ shaloi.Contacts }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="decision-btns ml-auto">
                  <button
                    class="btn px-5"
                    @click="clearTable"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card table-view">
        <DataTable
          :value="shalois"
          :paginator="true"
          class="p-datatable-customers"
          :rows="10"
          v-model:selection="selectedProducts3"
          dataKey="id"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50]"
          v-model:filters="filters2"
          filterDisplay="row"
          :loading="LoadingData"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          :globalFilterFields="[
            'firstname',
            'lastname',
            'phonenumber',
            'email',
          ]"
        >
          <template #header>
            <div class="p-d-flex p-jc-end">
              <span class="p-input-icon-left ">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters2['global'].value"
                  placeholder="Keyword Search"
                />
              </span>
            </div>
          </template>
          <template #empty>
            No buses found.
          </template>
          <template #loading>
            Loading buses data. Please wait.
          </template>
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column
            field="firstname"
            header="Shaloi first name"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.firstname }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['firstname'].value"
                class="p-column-filter"
                :placeholder="`Search by first name - `"
              />
            </template>
          </Column>

          <Column
            field="lastname"
            header="Shaloi lastname"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.lastname }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['lastname'].value"
                class="p-column-filter"
                :placeholder="`Search by last name - `"
              />
            </template>
          </Column>

          <Column
            field="phonenumber"
            header="Phone number"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.phonenumber }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['phonenumber'].value"
                class="p-column-filter"
                :placeholder="`Search by phone number - `"
              />
            </template>
          </Column>
          <Column
            field="email"
            header="Shaloi email"
            sortable="true"
            style="min-width:12rem"
          >
            <template #body="{data}">
              {{ data.email }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['email'].value"
                class="p-column-filter"
                :placeholder="`Search by email - `"
              />
            </template>
          </Column>
        </DataTable>
      </div>

      <!-- table card for mobile -->

      <div class="card mobile_cards_instead_of_table ">
        <DataView
          :value="shalois"
          :paginator="true"
          :rows="9"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
          <template #empty>
            No shalois found.
          </template>
          <template #list="slotProps">
            <div class="p-col-12">
              <div class="col-sm-12 col-12 single-card">
                <div class="sub-content d-flex">
                  <p class="title">Shaloi first name:</p>
                  <p class="content pl-2">{{ slotProps.data.firstname }}</p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Shaloi last name:</p>
                  <p class="content pl-2">
                    {{ slotProps.data.lastname }}
                  </p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Shaloi phone number:</p>
                  <p class="content pl-2">{{ slotProps.data.phonenumber }}</p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Shaloi email:</p>
                  <p class="content pl-2">{{ slotProps.data.email }}</p>
                </div>
              </div>
            </div>
          </template>
        </DataView>
      </div>

      <div class="d-flex loader" v-if="LoadingData">
        <span
          v-if="true"
          class="spinner-border spinner-border-sm ml-2 my-auto"
        ></span>
        <p>Please wait. We are loading data...</p>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import phoneCodes from "../../user-management/phoneCodes.json";
import $ from "jquery";
import { FilterMatchMode } from "primevue/api";
const companyName = localStorage.getItem("companyName");
import jwt_decode from "jwt-decode";
import axios from "axios";
const url = "https://bookinga.herokuapp.com/api/v1/company/shaloi";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  components: {},
  data: function() {
    return {
      selectedProducts3: null,
      filters2: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        firstname: { value: null, matchMode: FilterMatchMode.CONTAINS },
        lastname: { value: null, matchMode: FilterMatchMode.CONTAINS },
        email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        phonenumber: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      LoadingData: true,
      shalois: [],
      companyName: companyName,
      phoneCodes: phoneCodes.countries,
      modalClose: "",
      //--------------------------------------------------
      showTable: false,
      currentCode:"+250",
      location: "",
      name: "",
      AddedShalois: [],
      addShaloiClicked:false,
      shaloiId: "",
      clicksCounter: 0,
      shaloiData: {
        Firstname: "",
        phone: "",
        Lastname: "",
        email: "",
        Gender: "",
        selector: "+250",
      },
    };
  },
  mounted() {
    //API Call
    this.getShalois();
  },
  watch: {
    AddedShalois: {
      handler(val, oldVal) {
        this.getShalois();
      },
      deep: true,
    },
  },
  methods: {
    clearTable() {
      this.AddedShalois.unshift();
      this.showTable = false;
    },
    getCode() {
      this.currentCode = this.shaloiData.selector;
    },
    getShalois() {
      axios.get(url, config).then((res) => {
        if (res.data.message!="This company has no registered shaloi who leads a branch") {
          this.shalois = res.data.data;
          this.LoadingData = false;
        }
        else{
          this.LoadingData=false;
        }

      });
    },
    newShaloi() {
      if (
        this.shaloiData.phone != "" &&
        this.shaloiData.email != "" &&
        this.shaloiData.Gender == "" &&
        this.shaloiData.FirstName != "" &&
        this.shaloiData.Lastname != ""
      ) {
        this.addShaloiClicked=true;
        axios
          .post(
            url,
            {

              firstName: this.shaloiData.Firstname,
              lastName: this.shaloiData.Lastname,
              email: this.shaloiData.email,
              gender: this.shaloiData.Gender,
              phoneNumber: this.currentCode + this.shaloiData.phone,
            },
            config
          )
          .then((res) => {
            if (res.data.status == 201) {
              this.addShaloiClicked=false;
              this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Shaloi saved successfully",
                group: "br",
                life: 5000,
              });
              this.clicksCounter++;
              this.AddedShalois.push({
                no: this.clicksCounter,
                Firstname: this.shaloiData.Firstname,
                Lastname: this.shaloiData.Lastname,
                Email: this.shaloiData.email,
                gender: this.shaloiData.Gender,
                shaloiId: this.shaloiData.shaloiId,
                Contacts: this.currentCode + this.shaloiData.phone,
              });
              this.shaloiData.Firstname = "";
              this.shaloiData.Lastname = "";
              this.shaloiData.email = "";
              this.shaloiData.Gender = "";
              this.shaloiData.phone = "";
              return (this.showTable = true);
            } else {
              this.addShaloiClicked=false;
              this.$toast.add({
                severity: "error",
                summary: "Error message",
                detail: res.data.message,
                group: "br",
                life: 5000,
              });
            }
          })
          .catch((error) => {
            this.addShaloiClicked=false;
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: error.message,
              group: "br",
              life: 5000,
            });
          });
      } else {
        this.$toast.add({
          severity: "info",
          summary: "Information",
          detail: "All the fields are required",
          group: "br",
          life: 5000,
        });
      }
    },
  },

  created() { 
    // const token = localStorage.getItem("jwt");
    // const decoded = jwt_decode(token);
    // const userRole = decoded.role;
    // if ( userRole != "admin") {
    //   return router.push("/dashboard");
    // }
       
    $(document).ready(function() {
      $(".show-modal").click(function() {
        $("#myModal").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    });
  },
};
</script>
<style lang="scss" scoped>
@import "../sharedStyles.scss";
.add-shaloi-btn-div {
  height: fit-content !important;
}
.add-shaloi-btn-div > button {
  min-width: 80% !important;
}
</style>
